export default __webpack_public_path__ + "static/media/ken_jezelf.1d59ee47.jpg";